export const esignGalleryTool = {
  "tab": {
    "in": "",
    "out": ""
  },
  "tooltip": {
    "in": "",
    "out": ""
  },
  "gallery": {
    "addBtn": "",
    "addBtnOutTips": "",
    "inTips": "",
    "addBtnInTips": "",
    "head": {
      "in": "",
      "out": ""
    }
  },
  "selectDialog": {
    "title": "",
    "outTitle": "",
    "inTitle": "",
    "outContent": "",
    "outContent2": "",
    "inContent": "",
    "outBtn": "",
    "inBtn": ""
  }
}